import React from "react";
import { initials, avatarColor } from "./allocUtils";

export function Avatar({ id, name, size = 28, ring = true }) {
  return (
    <span title={name} style={{ width: size, height: size, background: avatarColor(id), fontSize: size * 0.38 }}
      className={`inline-flex items-center justify-center rounded-full text-white font-semibold shrink-0 ${ring ? "ring-2 ring-white" : ""}`}>
      {initials(name)}
    </span>
  );
}

export function AvatarStack({ people, max = 5, testid }) {
  const shown = people.slice(0, max);
  const rest = people.length - shown.length;
  if (!people.length) return <span className="text-[12px] text-ink-muted" data-testid={testid}>Fără echipă</span>;
  return (
    <div className="flex -space-x-2" data-testid={testid}>
      {shown.map((p) => <Avatar key={p.id} id={p.id} name={p.name} size={26} />)}
      {rest > 0 && (
        <span className="inline-flex items-center justify-center h-[26px] min-w-[26px] px-1 rounded-full bg-slate-100 text-slate-600 text-[10px] font-semibold ring-2 ring-white">+{rest}</span>
      )}
    </div>
  );
}
